import React, { useEffect, useRef } from "react";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { readSlugs, writeRead, PROGRESS_EVENT } from "@/lib/startHere";

// Merges browser reading progress with the signed-in account, then keeps both in sync.
export default function PathSync() {
  const { user } = useAuth();
  const synced = useRef("");

  useEffect(() => {
    if (!user) return undefined;
    let alive = true;
    const push = async () => {
      const local = [...readSlugs()].sort();
      const key = JSON.stringify(local);
      if (key === synced.current) return;
      try {
        const { data } = await api.post("/me/reading-progress", { read: local });
        if (!alive) return;
        const merged = [...new Set(data.read || [])].sort();
        synced.current = JSON.stringify(merged);
        if (synced.current !== key) writeRead(merged);
      } catch {
        /* offline or signed out — browser progress still works */
      }
    };
    push();
    window.addEventListener(PROGRESS_EVENT, push);
    return () => {
      alive = false;
      window.removeEventListener(PROGRESS_EVENT, push);
    };
  }, [user]);

  return null;
}
